<template>
<div class="chapter">
<div class="inner_page">
<div id="sec-7">
<h1 class="h1" id="pz7-1">CONTENTS</h1>
<p class="toc" id="pz7-2"><a href="#/frontmatter02#pz9-1" id="x1"><b>Acknowledgments</b></a></p>
<p class="toc" id="Asf"><a href="#/chapter01#pz11-8" id="x2"><b>Chapter One</b></a></p>
<p class="toca" id="AFp"><a href="#/chapter01#pz11-7" id="x3">An Invitation to Discipleship</a></p>
<p class="toc" id="Aux"><span href="#/chapter02#pz25-6" id="x4" title="Link target outside of Sample"><b>Chapter Two</b></span></p>
<p class="toca" id="AJW"><span href="#/chapter02#pz25-7" id="x5" title="Link target outside of Sample">Starting with God: The Trinity</span></p>
<p class="toc" id="AhG"><span href="#/chapter03#pz47-6" id="x6" title="Link target outside of Sample"><b>Chapter Three</b></span></p>
<p class="toca" id="AiA"><span href="#/chapter03#pz47-8" id="x7" title="Link target outside of Sample">Participating in God’s Story: Eschatology</span></p>
<p class="toc" id="A4tG"><span href="#/chapter04#pz69-8" id="x8" title="Link target outside of Sample"><b>Chapter Four</b></span></p>
<p class="toca" id="A6Ig"><span href="#/chapter04#pz69-7" id="x9" title="Link target outside of Sample">Encountering the Living Word: Scripture</span></p>
<p class="toc" id="A26"><span href="#/chapter05#pz91-7" id="x10" title="Link target outside of Sample"><b>Chapter Five</b></span></p>
<p class="toca" id="AWay"><span href="#/chapter05#pz91-8" id="x11" title="Link target outside of Sample">Pursuing Intentional Discipleship: The Believers Church</span></p>
<p class="toc" id="AVSG"><span href="#/chapter06#pAB63" id="x12" title="Link target outside of Sample"><b>Chapter Six</b></span></p>
<p class="toca" id="ABE"><span href="#/chapter06#pz115-7" id="x13" title="Link target outside of Sample">Experiencing God in Community: The Sacraments</span></p>
<p class="toc" id="A7S"><span href="#/chapter07#pz137-8" id="x14" title="Link target outside of Sample"><b>Chapter Seven</b></span></p>
<p class="toca" id="AO90"><span href="#/chapter07#pz137-7" id="x15" title="Link target outside of Sample">Participating in God’s Purposes: Mission</span></p>
<p class="toc" id="AQW"><span href="#/chapter08#pz159-8" id="x16" title="Link target outside of Sample"><b>Chapter Eight</b></span></p>
<p class="toca" id="AZd"><span href="#/chapter08#pz159-7" id="x17" title="Link target outside of Sample">Theological Commitments in Churches of Christ</span></p>
<p class="toc" id="AqL_"><span href="#/backmatter01#pz165-1" id="x18" title="Link target outside of Sample"><b>Response</b></span></p>
<p class="toca" id="Ae1g"><span href="#/backmatter01#pz165-2" id="x19" title="Link target outside of Sample">by Lauren Smelser White</span></p>
<p class="toc" id="AGT"><span href="#/backmatter02#pz172-1" id="x20" title="Link target outside of Sample"><b>Response</b></span></p>
<p class="toca" id="AKll"><span href="#/backmatter02#pz172-2" id="x21" title="Link target outside of Sample">by Stanley Talbert</span></p>
<p class="toc" id="Ay-"><span href="#/backmatter03#pz177-1" id="x22" title="Link target outside of Sample"><b>Response</b></span></p>
<p class="toca" id="AY2X"><span href="#/backmatter03#pz177-2" id="x23" title="Link target outside of Sample">by Carson E. Reed</span></p>
<p class="toc" id="Aqv6"><span href="#/backmatter04#pz185-6" id="x24" title="Link target outside of Sample"><b>Appendix One:</b></span></p>
<p class="toca" id="Auv"><span href="#/backmatter04#pz185-7" id="x25" title="Link target outside of Sample">Rules of Faith and Ecumenical Creeds of the Early Church</span></p>
<p class="toc" id="A6Q-"><span href="#/backmatter05#pz189-1" id="x26" title="Link target outside of Sample"><b>Appendix Two:</b></span></p>
<p class="toca" id="AWX"><span href="#/backmatter05#pz189-2" id="x27" title="Link target outside of Sample">Alexander Campbell’s “Summary View of the Christian System of Facts”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contenttoc.vue?1d7d5053